import { combineReducers } from 'redux';
import graphs from './graphs';

export default combineReducers({
  graphs,
});
